import * as React from 'react';
import type * as Immutable from 'immutable';

import { singleton } from 'logic/singleton';

type PreviewLayoutContextValue = {
  widgetEdit?: {
    fieldSelectInfo?: React.ReactNode;
    fieldsCreationAllowed?: boolean;
    formInfo?: React.ReactNode;
    showFieldSelect?: boolean;
  };
  defaultFields: Immutable.OrderedSet<string>;
  timestampField?: string;
};
const PreviewLayoutContext = React.createContext<PreviewLayoutContextValue | undefined>(undefined);

export default singleton('contexts.PreviewLayoutContext', () => PreviewLayoutContext);
